// This JavaScript file is created by Cision for our ownership module.
// This is the first version of this file so far.
// This should be combined with ownership.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.ownership = !cision.websolution.settings.ownership ? {} : function ($) {

    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.ownership.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }
    var renderLargestShareholders = function (options) {
        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ownership access key.");
            return;
        }
        var url = generateUrl('Ownership/' + accessKey);

        $.ajax({
            url: url,
                type: 'GET',
                dataType: 'json'
            })
            .done(function (rawData) {
                rawData.TotalAmount = rawData.ShareHolders.length;
                rawData.DateFormatted = moment(rawData.Date).format('ll');
                rawData.AmountInList = settings.LargestListShowCount;

                renderLargestShareholdersChart(options, rawData);

                var compositeModel = $.extend(rawData, texts, settings);

                var renderedHtml = $("#tplLargestShareholdersListing").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-largestshareholders").html(renderedHtml);
            })
            .fail(function() {
                console.log('Could not retrieve data');
            });
    };

    var renderLargestShareholdersChart = function (options, rawData) {
        // Build Data Series
        var dataArray = [],
            othersPercent = 100;
        //        options.LargestPieShowCount = 10;
        $.each(rawData.ShareHolders, function (ix, objShareHolder) {
            if (objShareHolder.Number <= settings.LargestPieShowCount) {
                othersPercent -= objShareHolder.OwnershipPercent;

                dataArray.push({
                    name: objShareHolder.Name,
                    y: objShareHolder.OwnershipPercent
                });
            }
        });

        if (othersPercent > 0) {
            dataArray.push({
                name: 'Others',
                y: othersPercent,
                sliced: true
            });
        }

        $('#container-largest-shareholders-chart').highcharts({
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false
            },
            title: {
                text: ''
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            credits: {
                text: 'Source Cision/Euroclear'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        color: '#000000',
                        connectorColor: '#000000',
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
                type: 'pie',
                name: rawData.Name,
                data: dataArray
            }]
        });
    };

    var renderNewShareholders = function (options) {
        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ownership access key.");
            return;
        }

        var url = generateUrl('Ownership/' + accessKey + '/NewShareHolders');

        $.ajax({
            url: url,
                type: 'GET',
                dataType: 'json'
            })
            .done(function(rawData) {

                rawData.DateFormatted = moment(rawData.Date).format('ll');

                var compositeModel = $.extend(rawData, texts, settings);

                var renderedHtml = $("#tplNewShareholdersListing").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-newshareholders").html(renderedHtml);
            })
            .fail(function() {
                console.log('Could not retrieve data');
            });
    };

    var renderShareSizeGroups = function (options) {
        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ownership access key.");
            return;
        }

        var url = generateUrl('Ownership/' + accessKey + '/ShareSizeGroups');

        $.ajax({
            url: url,
                type: 'GET',
                dataType: 'json'
            })
            .done(function(rawData) {

                rawData.DateFormatted = moment(rawData.Date).format('ll');

                var compositeModel = $.extend(rawData, texts, settings);

                var renderedHtml = $("#tplShareSizeGroupsListing").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-sharesizegroups").html(renderedHtml);
            })
            .fail(function() {
                console.log('Could not retrieve data');
            });
    };

    var renderShareHolderAreas = function (options) {
        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ownership access key.");
            return;
        }

        var url = generateUrl('Ownership/' + accessKey + '/ShareHolderAreas');

        $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json'
            })
            .done(function(rawData) {
                // Trying to reorder Areas so that they are translatable
                // The available areas are: Sweden, USA, Nordic, Europe, World
                var reorderedAreas = [];
                settings.ownershipAreasNames = settings.ownershipAreasNames || {};
                var textsAreaNames = texts.TextOwnershipAreaNames || {};

                var objAreaSweden = _.findWhere(rawData.Areas,
                {
                    AreaName: settings.ownershipAreasNames.sweden || 'SVERIGEBOENDE'
                });
                if (objAreaSweden) {
                    objAreaSweden.AreaName = textsAreaNames.Sweden || objAreaSweden.AreaName;
                    reorderedAreas.push(objAreaSweden);
                }

                var objAreaUsa = _.findWhere(rawData.Areas,
                {
                    AreaName: settings.ownershipAreasNames.usa || 'USA'
                });
                if (objAreaUsa) {
                    objAreaUsa.AreaName = textsAreaNames.Usa || objAreaUsa.AreaName;
                    reorderedAreas.push(objAreaUsa);
                }

                var objAreaNordic = _.findWhere(rawData.Areas,
                {
                    AreaName: settings.ownershipAreasNames.nordic || 'ÖVRIGA NORDEN'
                });
                if (objAreaNordic) {
                    objAreaNordic.AreaName = textsAreaNames.Nordic || objAreaNordic.AreaName;
                    reorderedAreas.push(objAreaNordic);
                }

                var objAreaEurope = _.findWhere(rawData.Areas,
                {
                    AreaName: settings.ownershipAreasNames.europe || 'ÖVRIGA EUROPA (EXKL SVERIGE OCH NORDEN)'
                });
                if (objAreaEurope) {
                    objAreaEurope.AreaName = textsAreaNames.Europe || 'ÖVRIGA EUROPA' /* objAreaEurope.AreaName */;
                    reorderedAreas.push(objAreaEurope);
                }

                var objAreaWorld = _.findWhere(rawData.Areas,
                {
                    AreaName: settings.ownershipAreasNames.world || 'ÖVRIGA VÄRLDEN'
                });
                if (objAreaWorld) {
                    objAreaWorld.AreaName = textsAreaNames.World || objAreaWorld.AreaName;
                    reorderedAreas.push(objAreaWorld);
                }

                var objAreaTotal = _.findWhere(rawData.Areas, { OwnershipPercent: 100 });
                if (objAreaTotal) {
                    objAreaTotal.AreaName = textsAreaNames.Total || objAreaTotal.AreaName;
                }

                rawData.Areas = reorderedAreas;
                rawData.Total = objAreaTotal;

                rawData.DateFormatted = moment(rawData.Date).format('ll');

                var compositeModel = $.extend(rawData, texts, settings);

                var renderedHtml = $("#tplShareShareHolderAreasListing").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-shareholderareas").html(renderedHtml);

                renderShareHolderAreasChart(options, rawData);
            })
            .fail(function() {
                console.log('Could not retrieve data');
            });
    };

    var renderShareHolderAreasChart = function (options, rawData) {
        // Build Data Series
        var dataArray = [];

        $.each(rawData.Areas, function (ix, objArea) {
            if (objArea.OwnershipPercent < 100) {
                dataArray.push({
                    name: objArea.AreaName,
                    y: objArea.OwnershipPercent
                });
            }
        });

        $('#target-shareholderareas-chart').highcharts({
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false
            },
            title: {
                text: ''
            },
            credits: {
                text: 'Source Cision/Euroclear'
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        color: '#000000',
                        connectorColor: '#000000',
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
                type: 'pie',
                name: rawData.Name,
                data: dataArray
            }]
        });


    };

    var renderLargestGroupedShareholders = function (options) {
        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ownership access key.");
            return;
        }
        var url = generateUrl('Ownership/' + accessKey + '/LargestGroupedShareHolders');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json'
        })
            .done(function (rawData) {
                rawData.TotalAmount = rawData.ShareHolders.length;
                rawData.DateFormatted = moment(rawData.Date).format('ll');
                rawData.AmountInList = settings.LargestListShowCount;

                renderLargestGroupedShareholdersChart(options, rawData);

                var compositeModel = $.extend(rawData, texts, settings);
                console.log(compositeModel);
                var renderedHtml = $("#tplLargestShareholdersListing").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-largestgroupedshareholders").html(renderedHtml);
            })
            .fail(function() {
                console.log('Could not retrieve data');
            });
    };

    var renderLargestGroupedShareholdersChart = function (options, rawData) {
        // Build Data Series
        var dataArray = [],
            othersPercent = 100;
        //        options.LargestPieShowCount = 10;
        $.each(rawData.ShareHolders, function (ix, objShareHolder) {
            if (objShareHolder.Number <= settings.LargestPieShowCount) {
                othersPercent -= objShareHolder.OwnershipPercent;

                dataArray.push({
                    name: objShareHolder.Name,
                    y: objShareHolder.OwnershipPercent
                });
            }
        });

        if (othersPercent > 0) {
            dataArray.push({
                name: 'Others',
                y: othersPercent,
                sliced: true
            });
        }

        $('#container-largest-grouped-shareholders-chart').highcharts({
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false
            },
            title: {
                text: ''
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            credits: {
                text: 'Source Cision/Euroclear'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        color: '#000000',
                        connectorColor: '#000000',
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                    }
                }
            },
            series: [{
                type: 'pie',
                name: rawData.Name,
                data: dataArray
            }]
        });
    };
    return {
        renderLargestShareholders: renderLargestShareholders,
        renderNewShareholders: renderNewShareholders,
        renderShareSizeGroups: renderShareSizeGroups,
        renderShareHolderAreas: renderShareHolderAreas,
        renderShareHolderAreasChart: renderShareHolderAreasChart,
        renderLargestGroupedShareholders: renderLargestGroupedShareholders
    };

}(jQuery);